import { useCallback } from 'react'
import { InputBox, InputCreditCardSC } from './PopupComponents.styled'

export interface IInputDateCreditCard {
  errorMessage?: string
  onChangeMonthInput: (arg: string) => void
  onChangeYearInput: (arg: string) => void
  monthPlaceholderTitle?: string
  yearPlaceholderTitle?: string
}

export const InputDateCreditCard = ({
  errorMessage,
  onChangeMonthInput,
  onChangeYearInput,
  monthPlaceholderTitle = 'MM',
  yearPlaceholderTitle = 'YY',
}: IInputDateCreditCard) => {
  const maxLength = 2
  const handleMonth = useCallback((e: { target: { value: string } }) => {
    const newValue = +e.target.value
    e.target.value = newValue ? newValue.toString() : ''
    onChangeMonthInput(newValue.toString())
  }, [])
  const handleYear = useCallback((e: { target: { value: string } }) => {
    const newValue = +e.target.value
    e.target.value = newValue ? newValue.toString() : ''
    onChangeYearInput(newValue.toString())
  }, [])

  return (
    <InputCreditCardSC errorMessage={errorMessage!}>
      <InputBox
        name='cc-exp-month'
        autoComplete='cc-exp-month'
        maxLength={maxLength}
        inputMode='numeric'
        onChange={handleMonth}
        placeholder={monthPlaceholderTitle}
      />
      /
      <InputBox
        name='cc-exp-year'
        autoComplete='cc-exp-year'
        maxLength={maxLength}
        inputMode='numeric'
        onChange={handleYear}
        placeholder={yearPlaceholderTitle}
      />
    </InputCreditCardSC>
  )
}
